module.exports = __webpack_public_path__ + "static/media/jewellery.7bece3cf.JPG";